import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component } from 'react';

import FormInput, { FormInputProps } from '../../../../shared/components/FormInput';
import { withIdPrefix } from './withIdPrefix';

type ZipCodeProps = FormInputProps;

@observer
class ZipCode extends Component<ZipCodeProps> {
  render() {
    const { className, label, inputClassName, ...otherProps } = this.props;

    return (
      <FormInput
        label={label || 'Zip Code'}
        className={className}
        inputClassName={classNames(inputClassName)}
        {...otherProps}
      />
    );
  }
}

export default withIdPrefix(ZipCode, 'zipCode');
